import { ModuleType } from "../../queryKeyFactory";

export const messagingKeyFactory = {
   recipientLists: (recipientType: string): [ModuleType, "recipient-lists", string] =>
  ["ux", "recipient-lists", recipientType],
   templates: (channelType: string): [ModuleType, "get-templates", string] =>
  ["ux", "get-templates", channelType],
}